import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DataEndpoint } from '@core/models/general.model';
import { Observable, map } from 'rxjs';
import { EmissionsFactoryForFormFilterModel, EmissionsFactoryForFormModel, EmissionsFactoryPaginatedModel, EmissionsFactoryRequestModel } from '../models/emissions-factory.model';
import { HttpUtils } from '@core/utils/http.utils';

@Injectable({
  providedIn: 'root',
})
export class EmissionsFactoryApi {
  private readonly http = inject(HttpClient);
  private readonly EMISSION_FACTORS = '/EmissionFactor';


  getEmissionsFactorsByBusiness(request: EmissionsFactoryRequestModel): Observable<DataEndpoint<EmissionsFactoryPaginatedModel>> {
    const url = `${this.EMISSION_FACTORS}/by`;
    const params = HttpUtils.objectToHttpParams(request);

    return this.http.get<DataEndpoint<EmissionsFactoryPaginatedModel>>(url, { params })
      .pipe(map((data: DataEndpoint<EmissionsFactoryPaginatedModel>) => {
        return {...data}
      }));
  }



  getEmissionFactorForForm(request: EmissionsFactoryForFormFilterModel): Observable<DataEndpoint<EmissionsFactoryForFormModel[]>> {
    const url = `${this.EMISSION_FACTORS}/for-form`;
    const params = HttpUtils.objectToHttpParams(request);

    return this.http.get<DataEndpoint<EmissionsFactoryForFormModel[]>>(url, { params })
      .pipe(map((data: DataEndpoint<EmissionsFactoryForFormModel[]>) => {
        return {...data}
      }));
  }
}
